import { Comparable } from "@siteimprove/alfa-comparable";
/**
 * {@link https://www.w3.org/TR/css-cascade-5/#cascading-origins}
 * {@link https://www.w3.org/TR/css-cascade-5/#cascade-origin}
 *
 * @remarks
 * This enumeration mixes both Origin and importance because importance
 * reverses the comparison of some (but not all) origins in cascade sorting.
 * Mixing both here allows for the comparison to be simple number comparison,
 * which should be faster than looking at more than one field.
 *
 * Cascading origins are defined in ascending order; origins defined first have
 * lower precedence than origins defined later. Thus, an origin with higher
 * value takes precedence over an origin with lower value. This means that
 * comparing origins is the same as comparing numbers.
 *
 * @public
 */
export var Origin;
(function (Origin) {
    /**
     * {@link https://www.w3.org/TR/css-cascade-5/#cascade-origin-ua}
     */
    Origin[Origin["NormalUserAgent"] = 1] = "NormalUserAgent";
    /**
     * {@link https://www.w3.org/TR/css-cascade-5/#cascade-origin-user}
     */
    Origin[Origin["NormalUser"] = 2] = "NormalUser";
    /**
     * {@link https://www.w3.org/TR/css-cascade-5/#cascade-origin-author}
     */
    Origin[Origin["NormalAuthor"] = 3] = "NormalAuthor";
    /**
     * {@link https://www.w3.org/TR/css-cascade-5/#cascade-origin-animation}
     */
    Origin[Origin["Animation"] = 4] = "Animation";
    Origin[Origin["ImportantAuthor"] = 5] = "ImportantAuthor";
    Origin[Origin["ImportantUser"] = 6] = "ImportantUser";
    Origin[Origin["ImportantUserAgent"] = 7] = "ImportantUserAgent";
    /**
     * {@link https://www.w3.org/TR/css-cascade-5/#cascade-origin-transition}
     */
    Origin[Origin["Transition"] = 8] = "Transition";
})(Origin || (Origin = {}));
/**
 * @public
 */
(function (Origin) {
    function isImportant(origin) {
        return (Origin.ImportantAuthor <= origin && origin <= Origin.ImportantUserAgent);
    }
    Origin.isImportant = isImportant;
    function isAuthor(origin) {
        return origin === Origin.NormalAuthor || origin === Origin.ImportantAuthor;
    }
    Origin.isAuthor = isAuthor;
    Origin.compare = Comparable.compareNumber;
})(Origin || (Origin = {}));
//# sourceMappingURL=origin.js.map